<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
	icon: {
		type: String,
		default: null
	},
	iconLabel: {
		type: String,
		default: ''
	},
	title: {
		type: String,
		default: ''
	},
	subtitle: {
		type: String,
		default: ''
	},
	titleFont: {
		type: String,
		default: 'font-24-pro-bold'
	},
	subTitleFont: {
		type: String,
		default: ''
	},
	transparentSubtitle: {
		type: Boolean,
		default: false
	},
	black: {
		type: Boolean,
		default: false
	},
	left: {
		type: Boolean,
		default: false
	}
});
const modes = computed(() => ({
	'part-title-head_transparent-subtitle': props.transparentSubtitle,
	'part-title-head_black': props.black,
	'part-title-head_left': props.black,
}));
</script>
<template>
	<div :class="['part-title-head', modes]">
		<img
			v-if="icon"
			:src="icon"
			alt=""
			class="part-title-head__icon"
		>
		<p v-if="iconLabel" class="part-title-head__icon-label" v-html="iconLabel" />
		<h2
			v-if="title"
			v-html="title"
			:class="['part-title-head__title', titleFont]"
		></h2>
		<p
			v-if="subtitle"
			v-html="subtitle"
			:class="['part-title-head__subtitle', subTitleFont]"
		></p>
	</div>
</template>
<style lang="scss">
.part-title-head {
	text-align: center;
	margin-bottom: 3.2rem;

	@include min-desktop {
		margin-bottom: 6.4rem;
	}

	&_black {
		color: #3B343B;
	}

	&_left {
		text-align: left;
	}

	&_transparent-subtitle {
		.part-title-head {
			&__subtitle {
				opacity: 0.5;
			}
		}
	}

	&__icon-label {
		color: var(--color-active);
		margin-top: -0.6rem;
		margin-bottom: var(--title-gap, 1.6rem);
		@include min-desktop {
			@include font-18-pro-medium;
		}
	}

	&__title {
		@include min-desktop {
			@include font-32-pro-bold;
		}
		&:not(:last-child) {
			margin-bottom: var(--title-gap, 1.6rem);
		}
	}
	&__subtitle {
		color: var(--color-text);
		line-height: 1.2;
		opacity: 0.5;
	}
	&__icon {
		width: var(--icon-width, 4.6rem);
		@include min-desktop {
			--icon-width: 6.4rem;
		}
		&:not(:last-child) {
			margin-bottom: var(--icon-gap, 1.6rem);
		}
	}

	a {
		text-decoration: underline;
		color: #835b83;
		font-weight: 500;
	}
}
</style>
